import { Link } from "react-router-dom";

export default function UnderConstruction() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img
          src="/images/Construction worker using jackhammer__.png"
          alt="Construction worker using jackhammer"
          style={styles.image}
        />

        <h1 style={styles.title}>Page Under Construction</h1>

        <p style={styles.text}>
          This page is currently being updated. Please check back soon.
        </p>

        <Link to="/" style={styles.button}>
          Return Home
        </Link>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    background: "#f4f8fb",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    maxWidth: "650px",
    width: "100%",
    textAlign: "center",
    background: "#ffffff",
    padding: "40px 28px",
    borderRadius: "18px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
  },
  image: {
    maxWidth: "320px",
    width: "100%",
    height: "auto",
    marginBottom: "24px",
  },
  title: {
    fontSize: "2rem",
    color: "#2f6f89",
    marginBottom: "12px",
  },
  text: {
    fontSize: "1.1rem",
    color: "#444",
    marginBottom: "28px",
    lineHeight: "1.6",
  },
  button: {
    display: "inline-block",
    padding: "12px 22px",
    background: "#2f6f89",
    color: "#ffffff",
    textDecoration: "none",
    borderRadius: "10px",
    fontWeight: "600",
  },
};

{/*import { useMemo, useState } from "react";

const fiList = [
  {
    name: "AIM",
    acceptingNewClients: "Yes",
    region: "***",
    fringeRate: "25%",
    maxComhabRate: "$34",
    maxRespiteRate: "$21.50",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "Bi-Weekly",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },
  {
    name: "Hamaspik Rockland",
    acceptingNewClients: "***",
    region: "***",
    fringeRate: "***",
    maxComhabRate: "***",
    maxRespiteRate: "***",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "***",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },
  {
    name: "Hamaspik Kings County",
    acceptingNewClients: "***",
    region: "***",
    fringeRate: "***",
    maxComhabRate: "***",
    maxRespiteRate: "***",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "***",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },
  {
    name: "People Inc",
    acceptingNewClients: "***",
    region: "***",
    fringeRate: "***",
    maxComhabRate: "***",
    maxRespiteRate: "***",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "***",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },
  {
    name: "MNY",
    acceptingNewClients: "***",
    region: "***",
    fringeRate: "***",
    maxComhabRate: "***",
    maxRespiteRate: "***",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "***",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },
  {
    name: "HIFI",
    acceptingNewClients: "***",
    region: "***",
    fringeRate: "***",
    maxComhabRate: "***",
    maxRespiteRate: "***",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "***",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },


  {
    name: "ACCESS",
    acceptingNewClients: "***",
    region: "***",
    fringeRate: "***",
    maxComhabRate: "***",
    maxRespiteRate: "***",
    overtimeAllowed: "***",
    maxWeeklyHours: "***",
    mileageRate: "***",
    payrollSchedule: "***",
    processingTimeline: "***",
    invoiceTurnaroundTime: "***",
    electronicSubmissionRequired: "***",
    submissionMethod: "***",
    adaptiveEquipmentJustification: "***",
    notes: "***",
  },

];

export default function FIResources() {
  const [search, setSearch] = useState("");
  const [selectedFI, setSelectedFI] = useState(null);

  function displayValue(value) {
    return value || "Not provided";
  }

  const filteredFIs = useMemo(() => {
    const q = search.toLowerCase().trim();

    return fiList.filter((fi) => {
      const searchableText = [
        fi.name,
        fi.acceptingNewClients,
        fi.region,
        fi.fringeRate,
        fi.maxComhabRate,
        fi.maxRespiteRate,
        fi.overtimeAllowed,
        fi.maxWeeklyHours,
        fi.mileageRate,
        fi.payrollSchedule,
        fi.processingTimeline,
        fi.invoiceTurnaroundTime,
        fi.electronicSubmissionRequired,
        fi.submissionMethod,
        fi.adaptiveEquipmentJustification,
        fi.notes,
      ]
        .join(" ")
        .toLowerCase();

      return q === "" || searchableText.includes(q);
    });
  }, [search]);

  return (
    <div className="page">
      <section className="card">
        <h1>Fiscal Intermediaries (FI)</h1>

        <p className="intro">
          Compare Fiscal Intermediaries by important items families often need:
          whether they are accepting new clients, region served, fringe rate,
          ComHab and Respite rate limits, payroll process, mileage, overtime
          rules, and processing timelines.
        </p>

        <div className="notice-box">
          <strong>Important:</strong> FI rules, rates, and availability may
          change. Always confirm details directly with the FI before enrolling,
          hiring staff, submitting invoices, or purchasing services/items.
        </div>

        <div className="controls">
          <input
            type="text"
            placeholder="Search FI name, region, accepting status, payroll, rate, overtime..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search"
          />
        </div>

        <div className="tableWrap desktopOnly">
          <table>
            <thead>
              <tr>
                <th>FI Name</th>
                <th>Accepting New Clients</th>
                <th>Region Served</th>
                <th>Fringe Rate</th>
                <th>Max ComHab Rate</th>
                <th>Max Respite Rate</th>
                <th>Payroll Schedule</th>
                <th>Details</th>
              </tr>
            </thead>

            <tbody>
              {filteredFIs.length > 0 ? (
                filteredFIs.map((fi) => (
                  <tr key={fi.name}>
                    <td className="fiNameCell">{fi.name}</td>
                    <td>{displayValue(fi.acceptingNewClients)}</td>
                    <td>{displayValue(fi.region)}</td>
                    <td>{displayValue(fi.fringeRate)}</td>
                    <td>{displayValue(fi.maxComhabRate)}</td>
                    <td>{displayValue(fi.maxRespiteRate)}</td>
                    <td>{displayValue(fi.payrollSchedule)}</td>
                    <td>
                      <button
                        type="button"
                        className="contact-btn"
                        onClick={() => setSelectedFI(fi)}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-results">
                    No Fiscal Intermediaries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="mobileOnly">
          {filteredFIs.length > 0 ? (
            <div className="mobileCards">
              {filteredFIs.map((fi) => (
                <div className="fi-card" key={fi.name}>
                  <div className="fi-card-header">
                    <h3>{fi.name}</h3>
                  </div>

                  <div className="fi-card-body">
                    <p>
                      <strong>Accepting New Clients:</strong>{" "}
                      {displayValue(fi.acceptingNewClients)}
                    </p>
                    <p>
                      <strong>Region Served:</strong>{" "}
                      {displayValue(fi.region)}
                    </p>
                    <p>
                      <strong>Fringe Rate:</strong>{" "}
                      {displayValue(fi.fringeRate)}
                    </p>
                    <p>
                      <strong>Max ComHab Rate:</strong>{" "}
                      {displayValue(fi.maxComhabRate)}
                    </p>
                    <p>
                      <strong>Max Respite Rate:</strong>{" "}
                      {displayValue(fi.maxRespiteRate)}
                    </p>
                    <p>
                      <strong>Payroll:</strong>{" "}
                      {displayValue(fi.payrollSchedule)}
                    </p>
                  </div>

                  <div className="fi-card-actions">
                    <button
                      type="button"
                      className="contact-btn"
                      onClick={() => setSelectedFI(fi)}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-results">No Fiscal Intermediaries found.</p>
          )}
        </div>

        {selectedFI && (
          <div
            className="details-modal-overlay"
            onClick={() => setSelectedFI(null)}
          >
            <div className="details-modal" onClick={(e) => e.stopPropagation()}>
              <h2>{selectedFI.name}</h2>

              <p className="details-modal-subtitle">
                Fiscal Intermediary Details
              </p>

              <div className="contact-highlight">
                <div className="detail-box">
                  <strong>Accepting New Clients:</strong>
                  <br />
                  {displayValue(selectedFI.acceptingNewClients)}
                </div>

                <div className="detail-box">
                  <strong>Region Served:</strong>
                  <br />
                  {displayValue(selectedFI.region)}
                </div>

                <div className="detail-box">
                  <strong>Payroll Schedule:</strong>
                  <br />
                  {displayValue(selectedFI.payrollSchedule)}
                </div>
              </div>

              <div className="detail-grid">
                <div className="detail-box">
                  <strong>Fringe Rate:</strong>{" "}
                  {displayValue(selectedFI.fringeRate)}
                </div>

                <div className="detail-box">
                  <strong>Max ComHab Rate:</strong>{" "}
                  {displayValue(selectedFI.maxComhabRate)}
                </div>

                <div className="detail-box">
                  <strong>Max Respite Rate:</strong>{" "}
                  {displayValue(selectedFI.maxRespiteRate)}
                </div>

                <div className="detail-box">
                  <strong>Overtime Allowed?</strong>{" "}
                  {displayValue(selectedFI.overtimeAllowed)}
                </div>

                <div className="detail-box">
                  <strong>Max Weekly Hours:</strong>{" "}
                  {displayValue(selectedFI.maxWeeklyHours)}
                </div>

                <div className="detail-box">
                  <strong>Mileage Rate:</strong>{" "}
                  {displayValue(selectedFI.mileageRate)}
                </div>

                <div className="detail-box">
                  <strong>Electronic Submission Required?</strong>{" "}
                  {displayValue(selectedFI.electronicSubmissionRequired)}
                </div>

                <div className="detail-box">
                  <strong>Submission Method:</strong>{" "}
                  {displayValue(selectedFI.submissionMethod)}
                </div>

                <div className="detail-box">
                  <strong>Processing Timeline:</strong>{" "}
                  {displayValue(selectedFI.processingTimeline)}
                </div>

                <div className="detail-box">
                  <strong>Invoice Turnaround Time:</strong>{" "}
                  {displayValue(selectedFI.invoiceTurnaroundTime)}
                </div>

                <div className="detail-box">
                  <strong>
                    Requires Justification for Adaptive Equipment?
                  </strong>{" "}
                  {displayValue(selectedFI.adaptiveEquipmentJustification)}
                </div>

                <div className="detail-box full-width">
                  <strong>Notes for Families:</strong>
                  <br />
                  {displayValue(selectedFI.notes)}
                </div>
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="contact-btn"
                  onClick={() => setSelectedFI(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <style>{`
          .page {
            width: 100%;
            padding: 20px;
          }

          .card {
            background: white;
            width: 100%;
            max-width: none;
            padding: 32px;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0,0,0,.08);
          }

          h1 {
            text-align: center;
            margin-bottom: 10px;
            color: #111827;
          }

          .intro {
            text-align: center;
            max-width: 1000px;
            margin: 0 auto 22px auto;
            color: #4b5563;
            line-height: 1.6;
          }

          .notice-box {
            background: #eef6fa;
            border: 1px solid #d6e6ef;
            color: #374151;
            border-radius: 14px;
            padding: 16px 18px;
            line-height: 1.6;
            margin-bottom: 22px;
          }

          .controls {
            display: flex;
            gap: 15px;
            align-items: center;
            margin-bottom: 18px;
            flex-wrap: wrap;
          }

          .search {
            flex: 1 1 700px;
            min-width: 260px;
            padding: 14px;
            border-radius: 10px;
            border: 1px solid #ddd;
            font-size: 15px;
          }

          .desktopOnly {
            display: block;
          }

          .mobileOnly {
            display: none;
          }

          .tableWrap {
            width: 100%;
            overflow-x: auto;
            border: 1px solid #e5e7eb;
            border-radius: 14px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            min-width: 1050px;
            background: #fff;
          }

          th {
            background: #2f6f89;
            color: white;
            padding: 14px 12px;
            text-align: left;
            font-size: 15px;
          }

          td {
            padding: 14px 12px;
            border-bottom: 1px solid #eee;
            vertical-align: top;
            color: #1f2937;
          }

          tbody tr:hover {
            background: #f7fafc;
          }

          .fiNameCell {
            font-weight: 600;
            color: #111827;
          }

          .no-results {
            text-align: center;
            padding: 20px;
          }

          .contact-btn {
            background: #2f6f89;
            color: white;
            border: none;
            padding: 9px 14px;
            border-radius: 8px;
            cursor: pointer;
            font-weight: 600;
            white-space: nowrap;
            text-decoration: none;
            display: inline-block;
          }

          .contact-btn:hover {
            background: #25596e;
          }

          .mobileCards {
            display: grid;
            gap: 14px;
          }

          .fi-card {
            background: #ffffff;
            border: 1px solid #e6edf2;
            border-radius: 16px;
            padding: 16px;
            box-shadow: 0 4px 14px rgba(0,0,0,.05);
          }

          .fi-card-header h3 {
            margin: 0 0 10px 0;
            color: #1f2937;
            font-size: 1.1rem;
          }

          .fi-card-body {
            display: grid;
            gap: 8px;
          }

          .fi-card-body p {
            margin: 0;
            line-height: 1.5;
            color: #374151;
          }

          .fi-card-actions {
            margin-top: 14px;
          }

          .details-modal-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.35);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
            z-index: 1000;
          }

          .details-modal {
            background: white;
            width: 100%;
            max-width: 820px;
            max-height: 85vh;
            overflow-y: auto;
            padding: 28px;
            border-radius: 18px;
            box-shadow: 0 10px 40px rgba(0,0,0,.2);
          }

          .details-modal h2 {
            margin-top: 0;
            margin-bottom: 8px;
            color: #1f2937;
            text-align: center;
          }

          .details-modal-subtitle {
            margin-bottom: 22px;
            color: #6b7280;
            text-align: center;
          }

          .contact-highlight {
            background: #eef6fa;
            border: 1px solid #d6e6ef;
            border-radius: 14px;
            padding: 18px;
            margin-bottom: 20px;
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 10px;
            font-size: 1.05rem;
          }

          .detail-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 14px 20px;
          }

          .detail-box {
            line-height: 1.5;
            word-break: break-word;
            background: #f8fafc;
            border: 1px solid #e6edf2;
            border-radius: 12px;
            padding: 12px 14px;
          }

          .full-width {
            grid-column: 1 / -1;
          }

          .modal-actions {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 24px;
          }

          @media (max-width: 900px) {
            .page {
              padding: 12px;
            }

            .card {
              padding: 20px;
            }

            .controls {
              flex-direction: column;
              align-items: stretch;
            }

            .search {
              width: 100%;
              min-width: 0;
              flex: 1 1 auto;
            }

            .desktopOnly {
              display: none;
            }

            .mobileOnly {
              display: block;
            }

            .detail-grid,
            .contact-highlight {
              grid-template-columns: 1fr;
            }

            .details-modal {
              padding: 20px;
            }
          }
        `}</style>
      </section>
    </div>
  );
}

*/}